<template>
  <component :is="layout">
    <transition name="fade" mode="out-in">
      <template>
        <router-view />
      </template>
    </transition>
  </component>
</template>
<script>
const DEFAULT_LAYOUT = "main";
export default {
  data() {
    return {};
  },
  created() {},
  computed: {
    layout() {
      return (this.$route.meta.layout || DEFAULT_LAYOUT) + "-layout";
    }
  },
  methods: {}
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.asterisk-label label::after,
.asterisk::after {
  content: " *";
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
